import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row } from "react-table";
import ReactTooltip from "react-tooltip";

import { CaseReportSignature, AdminCaseList } from "pwapi";

import { bulkUpdateCases } from "shared/actions/admin/adminCasesActions";
import { AdminCaseListDetail } from "shared/reducers/admin/adminCasesReducer";

import { PathologyWatchButton } from "components/customInputs/buttons/Button";

import { AdminFieldSignature } from "../edit/fields";

const CasesBulkActions = ({
  selectedCases,
}: {
  selectedCases: Row<AdminCaseList | AdminCaseListDetail>[];
}) => {
  const [bulkSignature, setBulkSignature] = useState<
    CaseReportSignature | undefined
  >(undefined);
  const [specimenLength, setSpecimenLength] = useState<number>(0);

  const dispatch = useDispatch();

  const invalidCases = selectedCases.filter((row) => {
    return (
      row.original.is_screening ||
      row.original.status === AdminCaseList.status.FINALIZED ||
      row.original.status === AdminCaseList.status.LIS_PENDING ||
      row.original.status === AdminCaseList.status.DELETED ||
      row.original.status === AdminCaseList.status.ARCHIVED ||
      row.original.source === AdminCaseList.source.WPL
    );
  });

  useEffect(() => {
    if (selectedCases.length > 0) {
      const totalSpecimens = selectedCases.reduce(
        (sum, row) => sum + (row.original.specimens?.length || 0),
        0
      );
      setSpecimenLength(totalSpecimens);
    } else {
      setSpecimenLength(0);
    }
  }, [selectedCases]);

  return selectedCases?.length ? (
    <div className="AdminCaselist__bulkAction">
      <AdminFieldSignature
        label=""
        missingMessage="Select a Report Signature..."
        onChange={(newValue: {
          value: string;
          label: string;
          object: CaseReportSignature;
        }) => {
          setBulkSignature(newValue.object);
        }}
        value={bulkSignature}
        field="bulkSignature"
      />
      <PathologyWatchButton
        disabled={!bulkSignature?.id || selectedCases?.length === 0}
        onClick={() => {
          const caseIds = selectedCases
            .filter(
              (row) =>
                row.original?.id &&
                row.original.status !== AdminCaseList.status.ARCHIVED &&
                row.original.status !== AdminCaseList.status.DELETED &&
                row.original.status !== AdminCaseList.status.FINALIZED &&
                row.original.status !== AdminCaseList.status.LIS_PENDING &&
                row.original.source !== AdminCaseList.source.WPL &&
                !row.original.is_screening
            )
            .map((row) => row.original.id) as number[];
          dispatch(
            bulkUpdateCases(
              caseIds,
              "case_finalizing_signature",
              bulkSignature?.id
            )
          );
        }}
      >
        Update Finalizing Signature
      </PathologyWatchButton>
      <div aria-live="polite">
        {selectedCases.length} {selectedCases.length === 1 ? "case" : "cases"}{" "}
        selected ({specimenLength}{" "}
        {specimenLength === 1 ? "specimen" : "specimens"})
      </div>
      {invalidCases?.length ? (
        <>
          <div
            style={{ cursor: "pointer" }}
            data-for="bulk_action_message"
            data-tip=""
          >
            <FontAwesomeIcon
              icon="exclamation-circle"
              fontSize="1.5em"
              color="var(--red)"
            />
          </div>
          <ReactTooltip
            id="bulk_action_message"
            place="top"
            effect="solid"
            backgroundColor="transparent"
            borderColor="transparent"
            textColor="black"
            padding="0"
          >
            <div className="Tooltip Tooltip__warning">
              <div className="Tooltip__messageContainer">
                <span>Cases that will not be updated:</span>
                <br />
                {invalidCases.map((row) => (
                  <span key={row.original.id}>
                    {row.original.accession} - Case{" "}
                    {row.original.is_screening
                      ? "is in screening"
                      : row.original.source === AdminCaseList.source.WPL
                      ? "is a WPL case"
                      : `is ${row.original.status}`}
                  </span>
                ))}
              </div>
            </div>
          </ReactTooltip>
        </>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <></>
  );
};

export default CasesBulkActions;
